








































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {logService} from "@/services/logs";
import {LogElement} from "@/model/chatbot-log";
import ChatbotServiceLog from "@/components/ChatbotServiceLog.vue";
import moment from "moment";
import {ChatbotSession} from "@/model/chatbot-session";
//@ts-ignore
import JsonViewer from 'vue-json-viewer';


@Component({
  components: {ChatbotServiceLog, JsonViewer}
})
export default class WhatsAppConversation extends Vue {

  overlay = false

  dateRange = []

  selectedTypes: string[] = ['in','out', 'intent','context','logic','service']
  types = ['in','out', 'intent','context','logic','service']

  selectedLevels: string[] = ['TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'FATAL', 'OFF']
  levels = ['TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'FATAL', 'OFF']
  modal = false

  logElements: LogElement[] = []

  chatbotSession = new ChatbotSession();

  context: any = {}

  async mounted() {
    this.chatbotSession.msisdn = this.$route.query.msisdn as string;
    this.chatbotSession.brand = this.$route.query.brand as string;
    this.chatbotSession.channel = this.$route.query.channel as string;
    this.chatbotSession.entryPoint = this.$route.query.entryPoint as string;
    this.search();
  }

  get logs() {
    return this.logElements.filter(l => this.selectedTypes.indexOf(l.type) !== -1).filter( l => this.selectedLevels.indexOf(l.level) !== -1);
  }

  get dateRangeMillis() {
    const start = this.dateRange.length > 1 ? moment(this.dateRange[0], 'YYYY-MM-DD').valueOf() : Date.now() - 80000000;
    const end = this.dateRange.length > 1 ? moment(this.dateRange[1], 'YYYY-MM-DD').valueOf() : Date.now();
    return [start,end].sort( (a,b)  => a-b);
  }

  async search() {
    this.overlay = true;
    this.logElements = await logService.getLogs(this.chatbotSession.msisdn,this.dateRangeMillis[0],this.dateRangeMillis[1]);
    this.context = await logService.getContext(this.chatbotSession.msisdn, this.chatbotSession.brand, this.chatbotSession.channel,this.chatbotSession.entryPoint)
    this.overlay = false;
  }
}
